import { browserHelpers } from '@approvalmax/utils';
import { updateProfileData } from 'modules/first-start/actions';
import ProfileSetupForm from 'pages/auth/components/ProfileSetupForm/ProfileSetupForm';
import { ProfileFormData } from 'pages/auth/components/ProfileSetupForm/ProfileSetupForm.types';
import { FC, memo, useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { notificationService } from 'services/notification';
import { isWrongEmailSso, removeWrongEmailSso } from 'shared/helpers';

import { useSetupProfileMutation } from './hooks';
import { messages } from './ProfileStepContainer.messages';
import { ProfileArea } from './ProfileStepContainer.styles';
import { ProfileStepContainerProps } from './ProfileStepContainer.types';

const ProfileStepContainer: FC<ProfileStepContainerProps> = (props) => {
    const { profileData, hasInvitations, email, nextStep } = props;

    const dispatch = useDispatch();
    const { isLoading, mutate } = useSetupProfileMutation(profileData, browserHelpers.isMobile(), nextStep);

    const showSsoPanel = hasInvitations;

    const handleProfileFormChange = useCallback(
        (data: ProfileFormData) => {
            const profileData = { ...data, password: data.password ?? '' };

            dispatch(updateProfileData(profileData));
        },
        [dispatch]
    );

    useEffect(() => {
        if (isWrongEmailSso()) {
            notificationService.showErrorToast(messages.wrongEmailSso);
            removeWrongEmailSso();
        }
    }, []);

    return (
        <ProfileArea $withSso={showSsoPanel}>
            <ProfileSetupForm
                email={email}
                profileData={profileData}
                showPhoneField={!hasInvitations}
                isLoading={isLoading}
                showQuestions={!hasInvitations}
                showProgress={!hasInvitations}
                saveStateInLocalStorage
                showPasswordField
                showSsoPanel={showSsoPanel}
                onDataChange={handleProfileFormChange}
                onSubmit={mutate}
            />
        </ProfileArea>
    );
};

export default memo(ProfileStepContainer);
